import { CustomerDocumentGateway } from './customer-document-gateway.interface';

export const initCustomerDocumentAPI = (
  apiSlice: any,
  gateway: CustomerDocumentGateway
) => {
  apiSlice
    .enhanceEndpoints({
      addTagTypes: ['Document'],
    })
    .injectEndpoints({
      endpoints: (builder: any) => ({
        getCustomerDocumentsByProject: builder.query({
          query: gateway.getCustomerDocumentsByProject,
          providesTags: ['Document'],
        }),
        postCustomerSingleDocument: builder.mutation({
          query: gateway.postSingleDocument,
          invalidatesTags: ['Document'],
        }),
        getCustomerDocumentById: builder.query({
          query: gateway.getDocumentById,
          providesTags: ['Document'],
        }),
        getCustomerDocumentByProjectAndSlug: builder.query({
          query: gateway.getDocumentByprojectAndSlug,
          providesTags: ['Document'],
        }),
        getCustomerDocumentCategories: builder.query({
          query: gateway.getDocumentCategories,
          providesTags: ['Document'],
        }),
        getCustomerStandardizedDocuments: builder.query({
          query: gateway.getStandardizedDocuments,
          providesTags: ['Document'],
        }),
        patchCustomerSignDocument: builder.mutation({
          query: gateway.patchSignDocument,
          invalidatesTags: ['Document'],
        }),
        patchCustomerDocument: builder.mutation({
          query: gateway.patchDocument,
          invalidatesTags: ['Document'],
        }),
        deleteCustomerDocument: builder.mutation({
          query: gateway.deleteDocument,
          invalidatesTags: ['Document'],
        }),
      }),
      overrideExisting: false,
    });
};

export interface CustomerDocumentSliceType {
  useGetCustomerDocumentsByProjectQuery: Function;
  useLazyGetCustomerDocumentsByProjectQuery: Function;
  usePostCustomerSingleDocumentMutation: Function;
  useGetCustomerDocumentByIdQuery: Function;
  useGetCustomerDocumentByProjectAndSlugQuery: Function;
  useGetCustomerDocumentCategoriesQuery: Function;
  useLazyGetCustomerDocumentCategoriesQuery: Function;
  useGetCustomerStandardizedDocumentsQuery: Function;
  useLazyGetCustomerStandardizedDocumentsQuery: Function;
  usePatchCustomerSignDocumentMutation: Function;
  usePatchCustomerDocumentMutation: Function;
  useDeleteCustomerDocumentMutation: Function;
}
